

























import Vue from 'vue'
import Vuex from 'vuex'
import AppState from './AppState'
import AppStore from './AppStore'
import { debug } from './utilities'

import IntroSection from './components/IntroSection.vue'
import EndSection from './components/EndSection.vue'

import AnnouncementView from './components/Announcement.vue'
import CharacterView from './components/Character.vue'
import Apartment from './components/Apartment.vue'
import Dialogue from './components/Dialogue.vue'
import Commercial from './components/Commercial.vue'

let preloadedImageNames = [
"apartment-bg.png",
"apartment-couch.png",
"body-arms-down.png",
"body-arms-left.png",
"body-arms-right.png",
"body-arms-up.png",
"buzzer.png",
"default-body.png",
"elaine-angry.png",
"elaine-neutral.png",
"elaine-sarcastic.png",
"george-angry.png",
"george-happy.png",
"george-neutral.png",
"georgetiki.png",
"iphone.png",
"jerry-neutral.png",
"jerry-sarcastic.png",
"jerry-shame.png",
"jerry-shocked.png",
"jerry-skeptical.png",
"kramer-angry.png",
"kramer-happy.png",
"kramer-neutral.png",
"logo.png",
"newman-neutral.png",
"newman-angry.png",
"reporter-neutral.png",
"tv-and-reporter.png",
"tv.png",
"window-closed.png",
"window-open.png"
];

let preloadedImages: HTMLElement[] = []

export default Vue.extend({
  name: 'App',
  components: {
    IntroSection,
    EndSection,

    AnnouncementView, 
    CharacterView,
    Apartment,
    Dialogue,
    Commercial
  },
  data: function() {
    return {
      images: []
    }
  },
 created: function () {
    document.addEventListener('keydown', (e) => {
      if(!e.repeat) {
        this.handleKeyDown(e.key)
      }
    })
    debug.superSpeed = () => {
      this.$store.commit('superSpeedMode')
    }
    debug.triggerEvent = (name: string) => {
      this.$store.commit('triggerEvent', name)
    }
    this.preloadImages()
  },
  computed: Vuex.mapState({
    currentlyDisplayedEvent: function (state: AppState) { return state.currentlyDisplayedEvent },
    currentlyDisplayedDialogue: function (state: AppState) { return state.currentlyDisplayedDialogue },
    currentlyDisplayedCommercial: function (state: AppState) { return state.currentlyDisplayedCommercial },
    currentView: function (state: AppState) { return state.currentView }
  }),
  methods: {
    preloadImages: function () {
      let images = preloadedImageNames.map((imageName) => {
        let image = new Image();
        image.src = `/img/${imageName}`
        return image
      })
      preloadedImages = images;
    },
    switchView: function (viewName: string) {
      this.$store.commit('switchView', viewName)
    },

    handleKeyDown: function (key: string) {
      // console.log('keydown happened', key)
      switch (key) {
        case "Escape":
          this.rejectEvent()
          break
        case " ":
          this.acceptEvent()
          break
      }
    },

    acceptEvent: function () {
      this.$store.dispatch('acceptEvent')
    },

    rejectEvent: function () {
      this.$store.dispatch('rejectEvent')
    },
  }

});
